import useAPI from '@/hooks/useAPI';
import OrganizationRepository from '@/repositories/OrganizationRepository';
import { OrganizationsParams } from '@/repositories/OrganizationRepository/types';

const useOrganizations = ({
  params,
  enabled = true
}: {
  params: OrganizationsParams;
  enabled?: boolean;
}) => {
  const organizationRepository = OrganizationRepository();

  return useAPI({
    queryKey: ['getOrganizations', params],
    queryFn: async () => {
      return await organizationRepository.getOrganizations(params);
    },
    enabled
  });
};

export default useOrganizations;
